"use client";

import { useMessages } from "@/lib/i18n/useMessages";
import { Box, useTheme } from "@mui/material";
import RVOFaqComponent from "../faqs/RVOFaqComponent";
import { FaqQuestion } from "../faqs/RVOFaqTreeInterfaces";
import { SLContainer } from "../layout/SLContainer";

export const SLSectionFaqs = ({
  title,
  questions,
  backgroundColor,
}: {
  title?: string;
  questions: FaqQuestion[];
  backgroundColor?: string;
}) => {
  const theme = useTheme();
  const messages = useMessages();
  const resolvedTitle = title ?? messages.faqs.title;

  return (
    <Box
      component="section"
      sx={{
        backgroundColor: backgroundColor || theme.palette.secondary.light,
        width: "100%",
      }}
    >
      <SLContainer title={resolvedTitle} hasPaddingTop={true}>
        <RVOFaqComponent faqQuestions={questions} smallTitles />
      </SLContainer>
    </Box>
  );
};
